import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.8, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal for display headings
export function MaskedLines({ lines, className = "", lineClassName = "", start = true }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={start ? { y: "0%" } : {}}
            transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1], delay: 0.15 + i * 0.13 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
